import { Injectable, Inject } from '@angular/core';
import { Config } from "../model/config";
import { Observable, Subject } from "rxjs/Rx";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import { Http } from "@angular/http";
import { firebaseConfig } from '../../../environments/firebase.config';

@Injectable()
export class ConfigService {
    sdkdb: any;

    constructor(private db: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp,
        private http: Http) {
        this.sdkdb = fb.database().ref();
    }

    findConfigs(): Observable<Config> {
        return this.db.object(`configs`)
            .map(results => Config.fromJson(results))
            .take(1)
    }

    firebaseUpdate(dataToSave) {
        const subject = new Subject();

        this.sdkdb.update(dataToSave)
            .then(
            val => {
                subject.next(val);
                subject.complete();

            },
            err => {
                subject.error(err);
                subject.complete();
            }
            );

        return subject.asObservable();
    }

    saveConfig(config): Observable<any> {
        const userToSave = Object.assign({}, config);

        let dataToSave = {};
        dataToSave[`configs`] = userToSave;

        return this.firebaseUpdate(dataToSave);

    }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/services/config.service.ts